import { inject, Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { GetUserRegions } from './user.actions';
import { UserStateModel } from './user.state.model';
import { UserService } from 'src/app/shared/services/user.service';
import { filter, tap } from 'rxjs/operators';
import { RegionDto } from 'src/app/shared/dtos/user.dto';
import { Observable } from 'rxjs';

@State({
  name: 'user',
  defaults: {
    regions: []
  }
})

@Injectable()
export class UserState {
  userService = inject(UserService);

  @Selector()
  static getUserRegions(state: UserStateModel): RegionDto[] {
    return state.regions;
  }

  @Action(GetUserRegions)
  getUserRegions(ctx: StateContext<UserStateModel>, action: GetUserRegions): Observable<RegionDto[] | null> | void {
    const userState = ctx.getState();

    if (!action.forceRefresh && userState.regions && userState.regions.length > 0) {
      return;
    }

    return this.userService.getUserRegions().pipe(
      filter((regions): regions is RegionDto[] => regions !== null && regions.length > 0),
      tap((regions: RegionDto[]) => {
        const state = ctx.getState();
        ctx.setState({
          ...state,
          regions: regions
        });
      })
    );
  }
}
